import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Terracotta urgency block that sits directly above the price card. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  return <div className="mx-auto max-w-xl rounded-4xl border border-terracotta/40 bg-terracotta px-6 py-7 text-center shadow-lift sm:px-9" data-id="element-57" data-mp="1aekabu759fn1">
      <p className="flex items-center justify-center gap-2 font-sans text-[11px] font-semibold uppercase tracking-[0.18em] text-ivory" data-id="element-58" data-mp="34ra14327u8q7">
        <AlarmClockIcon className="h-4 w-4 text-gold-soft" strokeWidth={1.9} aria-hidden="true" data-id="element-59" data-mp="2zs6wuku286ja" />
        Launch pricing ends in:
      </p>

      {isExpired ? <p className="mt-4 font-display text-xl leading-snug text-ivory" data-id="element-60" data-mp="1h0b12m23ytxf">
          Today’s launch pricing has ended.
        </p> : <>
          <div className="mt-5 flex items-center justify-center gap-2 sm:gap-3" aria-hidden="true" data-id="element-61" data-mp="123slypqvzpt1">
            {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-62" data-mp="173oki9gtep17" data-mpi={index}>
                <div className="flex min-w-[4.5rem] items-baseline justify-center gap-1 rounded-2xl bg-shell px-3 py-2.5 sm:min-w-[5.5rem]" data-id="element-63" data-mp="1uqwpeqabzw2p">
                  <span className="font-display text-3xl leading-none text-ink sm:text-4xl" data-id="element-64" data-mp="1zsc7qal4johe">
                    {pad(unit.value)}
                  </span>
                  <span className="font-sans text-[10px] font-semibold uppercase tracking-[0.1em] text-stone" data-id="element-65" data-mp="1pzoflt53a8p0">
                    {unit.label}
                  </span>
                </div>
                {index < units.length - 1 ? <span className="font-display text-2xl text-ivory/70" data-id="element-66" data-mp="2ihiuc8p1h08h">:</span> : null}
              </React.Fragment>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-67" data-mp="2samzqtktj3ky">
            {hours} hours, {minutes} minutes and {seconds} seconds left at launch
            pricing.
          </p>

          <p className="mx-auto mt-5 max-w-sm font-sans text-[0.82rem] font-medium leading-snug text-ivory" data-id="element-68" data-mp="2jaq7khz7zml5">
            After this the price returns to {'$137.00'} — pay once today and use
            it forever.
          </p>
        </>}
    </div>;
}